<template>
  <Content>
    <label
      v-if="$store.getters.identificationClient.length == 14">Você está conectado a empresa:
      {{ $store.getters.nameClient }} -
      {{ $store.getters.identificationClient| mask('##.###.###/####-##') }}
    </label>
    <label
      v-else>Você está conectado a empresa:
      {{ $store.getters.nameClient }} -
      {{ $store.getters.identificationClient| mask('###.###.###-##') }}
    </label>

    <div class="md-layout md-gutter">
      <div class="div-btn-left">
        <md-button
          class="md-icon-button"
          @click="getXMLAll()">
          <md-icon>cloud_download
          </md-icon>
        </md-button>
        <md-tooltip md-direction="bottom">Baixar documentos filtrados</md-tooltip>
      </div>
      <div>
        <button
          type="button"
          class="md-button md-icon-button md-theme-default"
          @click="setDefault(0)">
          <div class="md-ripple">
            <div class="md-button-content">
              <i class="md-icon md-icon-font md-theme-default">rotate_left
              </i>
            </div>
          </div>
          <md-tooltip md-direction="bottom">Limpar filtros</md-tooltip>
        </button>
      </div>

      <div
        class="md-layout-item md-size-35"
        style="margin-top: 25px; margin-left: 5px;">
        <date-picker
          v-model="dateEmissionFrom"
          lang="pt-br"
          format="DD/MM/YYYY"
          width="150"
          placeholder="De"/>
        <date-picker
          v-model="dateEmissionTo"
          lang="pt-br"
          format="DD/MM/YYYY"
          width="150"
          placeholder="Até"
          @input="setItens(1)"/>
        <md-tooltip
          md-direction="bottom">Após informar os dois campos, o filtro será feito
        </md-tooltip>
      </div>
      <div class="md-layout-item md-size-20 filter-model">
        <md-field>
          <md-select
            id="model"
            v-model="model"
            name="model"
            placeholder="Modelo Eletrônico"
            @input="setItens(2)">
            <md-option value="55">Nota Fiscal Eletrônica</md-option>
            <md-option value="65">Nota Fiscal de Consumidor</md-option>
            <md-option value="59">SAT</md-option>
          </md-select>
          <md-tooltip md-direction="bottom">Filtrar pelo tipo de Documento</md-tooltip>
        </md-field>
      </div>
      <div class="md-layout-item md-size-15">
        <md-field>
          <md-select
            id="typeFilter"
            v-model="typeFilter"
            name="typeFilter">
            <md-option value="1">Número</md-option>
            <md-option value="2">Chave de acesso</md-option>
            <md-option value="3">Nome do cliente</md-option>
            <md-option value="4">CNPJ/CPF cliente</md-option>
            <md-option value="5">Status</md-option>
          </md-select>
          <md-tooltip md-direction="bottom">Escolha a opção para realizar o filtro</md-tooltip>
        </md-field>
      </div>


      <div
        v-show="typeFilter === '1'"
        class="md-layout-item md-size-25">
        <md-field>
          <label>Número</label>
          <md-input
            v-model="number"
            placeholder="Número do documento"
            @keyup.enter="setItens(4)"/>
        </md-field>
        <md-tooltip md-direction="bottom">Pressione Enter para realizar a busca</md-tooltip>
      </div>

      <div
        v-show="typeFilter === '2'"
        class="md-layout-item md-size-28">
        <md-field>
          <label>Chave de Acesso</label>
          <md-input
            v-model="chaveAcesso"
            placeholder="Chave de Acesso"
            @keyup.enter="setItens(3)"/>
        </md-field>
        <md-tooltip md-direction="bottom">Pressione Enter para realizar a busca</md-tooltip>
      </div>

      <div
        v-show="typeFilter === '3'"
        class="md-layout-item md-size-25">
        <md-field>
          <label>Nome do cliente</label>
          <md-input
            v-model="customerName"
            placeholder="Nome do cliente"
            @keyup.enter="setItens(5)"/>
        </md-field>
        <md-tooltip md-direction="bottom">Pressione Enter para realizar a busca</md-tooltip>
      </div>

      <div
        v-show="typeFilter === '4'"
        class="md-layout-item md-size-15">
        <md-field>
          <label>CNPJ/CPF do cliente</label>
          <md-input
            v-model="customerIdentification"
            placeholder="CNPJ/CPF do cliente"
            @keyup.enter="setItens(6)"/>
        </md-field>
        <md-tooltip md-direction="bottom">Pressione Enter para realizar a busca</md-tooltip>
      </div>

      <div
        v-show="typeFilter === '5'"
        class="md-layout-item md-size-30">
        <md-field>
          <md-select
            id="statusDoc"
            v-model="statusDoc"
            placeholder="Selecione o status"
            name="statusDoc"
            @input="setItens(7)"
          >
            <md-option value="1">Autorizadas</md-option>
            <md-option value="2">Canceladas</md-option>
            <md-option value="3">Inutilizadas</md-option>
          </md-select>
        </md-field>
      </div>
    </div>


    <div
      v-if="isLoading"
      class="md-card-graph-total loading-total">
      <Spinner
        name="line-scale-pulse-out-rapid"
        color="#448aff"
        no-fade-in/>
        </Spinner>
    </div>

    <md-table
      v-if="!isLoading"
      v-model="listDocs"
      :md-selected-value.sync="selected"
      md-card
      md-fixed-header
      @md-selected="onSelect">

      <md-table-toolbar>
        <label class="title-card">Total de documentos: {{ totalListDocs }}</label>
      </md-table-toolbar>

      <md-table-toolbar
        slot="md-table-alternate-header"
        slot-scope="{ count }"
        class="md-selecao">
        <div class="md-toolbar-section-start">{{ getAlternateLabel(count) }}</div>

        <div class="div-action">
          <md-button
            class="md-icon-button"
            @click="getPdfUrl()">
            <md-icon>print
            </md-icon>
          </md-button>
          <md-tooltip md-direction="bottom">Visualizar Documento</md-tooltip>
        </div>
        <div class="div-action">

          <md-button
            class="md-icon-button"
            @click="getXML()">
            <md-icon>cloud_download
            </md-icon>
          </md-button>
          <md-tooltip md-direction="bottom">Baixar XML</md-tooltip>
        </div>
      </md-table-toolbar>


      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
        md-selectable="multiple"
        md-auto-select
      >
        <md-table-cell
          v-if="item.status === UNUTILIZED"
          md-label="Status"><label class="label-grey">Inutilizada</label>
        </md-table-cell>
        <md-table-cell
          v-if="item.status === CANCELED"
          md-label="Status"><label class="label-red">Cancelada</label>
        </md-table-cell>
        <md-table-cell
          v-if="item.status === null || item.status === AUTHORIZED"
          md-label="Status"><label class="label-green">Autorizada</label>
        </md-table-cell>
        <md-table-cell
          md-label="Número"
          md-numeric>{{ item.number }}</md-table-cell>
        <md-table-cell
          md-label="Modelo"
          md-numeric>{{ item.model }}</md-table-cell>
        <md-table-cell
          v-if="item.type == SALE"
          md-label="Tipo"><label class="label-green">Venda</label></md-table-cell>
        <md-table-cell
          v-if="item.type == PURCHASE"
          md-label="Tipo"><label class="label-red">Compra</label></md-table-cell>
        <md-table-cell
          v-if="item.unutilizedXml"
          md-label="Tipo"><label class="label-grey">Nota Inutilizada</label>
        </md-table-cell>
        <md-table-cell
          md-label="Data Emissão"
          md-numeric>{{ formatDate(item.emission) }}</md-table-cell>
        <md-table-cell
          md-label="Chave de Acesso"
          md-numeric>{{ item.docKey }}</md-table-cell>
      </md-table-row>

      <div
        v-if="totalListDocs === 0"
        class="sem-total">
        <div class="title-total">
          <label class="title-card">Nenhum documento localizado</label>
        </div>
      </div>
    </md-table>

    <div class="md-layout">
      <div class="md-layout-item md-size-10">
        <md-field>
          <md-select
            id="registers"
            v-model="registers"
            name="registers"
            placeholder="Registros"
            @input="setRegisterPerPage()">
            <md-option value="15">15</md-option>
            <md-option value="30">30</md-option>
            <md-option value="60">60</md-option>
          </md-select>
          <md-tooltip md-direction="bottom">Registros por página</md-tooltip>
        </md-field>
      </div>
      <div class="md-layout-item md-size-75">
        <Pagination
          v-if="!isLoading"
          :total="totalListDocs"
          :current_page="pageCurrent"
          :itens-per-page="itensPerPage"
          :offset="offset"
          :itens-page="itensPage"
          @next="onChangePage"/>
      </div>
    </div>

  </Content>
</template>
<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import { mapActions } from 'vuex'
import swal from 'sweetalert';
import { http } from '../../public/api/backend';
import Content from '../public/Content.vue';
import Pagination from '../../public/pagination/Pagination.vue';
import { filterConst } from '../../public/api/filterConst';
import { docStatus } from '../../public/api/docStatus';

export default {
  name: 'Documents',
  components: {
    Content,
    moment,
    Pagination,
    DatePicker
  },
  data() {
    return {
      client: this.$store.getters.client,
      itensPage: 15,
      page: 1,
      offset: 3,
      selected: [],
      dateEmissionFrom: null,
      dateEmissionTo: null,
      model: null,
      chaveAcesso: null,
      typeFilter: '1',
      number: null,
      docAllowed: 1,
      customerName: null,
      customerIdentification: null,
      searchFilter: null,
      registers: 15,
      statusDoc: null,
      itensPerPage: '',
    };
  },

  computed: {
    listDocs() {
      return this.$store.getters.getDoc.data
    },
    totalListDocs() {
      return this.$store.getters.getTotalDoc
    },
    idsDocs() {
      return this.$store.getters.getIdsDocs
    },
    perPageDocs() {
      return this.$store.getters.getPerPage
    },
    isLoading() {
      return this.$store.getters.isLoading
    },
    pageCurrent() {
      return this.$store.getters.getPage
    },
    identificationClient() {
      return this.$store.getters.identificationClient
    },
    AUTHORIZED() {
      return docStatus.AUTHORIZED
    },
    CANCELED() {
      return docStatus.CANCELED
    },
    UNUTILIZED() {
      return docStatus.UNUTILIZED
    },
    SALE() {
      return docStatus.SALE
    },
    PURCHASE() {
      return docStatus.PURCHASE
    }
  },

  mounted() {
    this.getDocuments()
  },
  methods: {

    getDocuments() {
      this.$store.dispatch('getDocuments')
    },

    onSelect(items) {
      this.selected = items
    },

    getAlternateLabel(count) {
      let plural = ''

      if (count > 1) {
        plural = 's'
      }
      return `${count} Documento${plural} selecionado${plural}`
    },

    getXMLAll() {
      swal({
        title: 'Deseja realizar o download do XML?',
        text: 'Aguarde, pois o download será feito automaticamente!',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.close()
            swal.stopLoading()
            return
          }

          const idsCollection = [];
          const zipLenght = 200

          if (this.selected.length > 0) {
            for (let i = 0; i < this.selected.length; i++) {
              idsCollection[i] = this.selected[i].id;
            }
            this.downloadXmlSelected(idsCollection)
            return
          }

          for (let i = 0; i < this.idsDocs.length; i += zipLenght) {
            const xmlPack = this.idsDocs.slice(i, i + zipLenght);
            idsCollection.push(xmlPack);
          }
          this.downloadXmlFilter(idsCollection)
        });
    },

    getXML() {
      swal({
        title: 'Deseja realizar o download do XML?',
        text: 'Aguarde, pois o download será feito automaticamente!',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.close()
            swal.stopLoading()
            return
          }

          const idsCollection = [];

          for (let i = 0; i < this.selected.length; i++) {
            idsCollection[i] = this.selected[i].id;
          }

          this.downloadXmlSelected(idsCollection);
        });
    },

    getPdfUrl() {
      if (this.selected.length === this.docAllowed) {
        swal({
          title: 'Deseja realizar a visualização do documento?',
          text: 'Aguarde, pois será gerado o PDF automaticamente!',
          icon: 'warning',
          buttons: {
            cancel: {
              text: 'Cancelar',
              value: 'cancel',
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: 'OK',
              visible: true,
              closeModal: false
            }
          },
          dangerMode: false,
          closeModal: false,
          closeOnClickOutside: false,
        })
          .then((value) => {
            if (value === 'cancel') {
              swal.close()
              swal.stopLoading()
              return
            }
            let idDoc = '';
            for (let i = 0; i < this.selected.length; i++) {
              idDoc = this.selected[i].id;
            }
            http.post('fiscal.get-storage-print-url', { id: idDoc })
              .then(response => {
                window.open(response.data.danfeUrl, '_blank');
                swal.stopLoading()
                swal.close()
              })
              .catch(error => {
                this.$toasted.show(error.response.data.error_message, {
                  theme: 'outline',
                  position: 'bottom-right',
                  duration: 5000,
                  type: 'error',
                  icon: 'error_outline'
                });
                swal.stopLoading()
                swal.close()
              })
          });
        return
      }
      this.$toasted.show('Selecione somente um documento!', {
        theme: 'outline',
        position: 'bottom-right',
        duration: 5000,
        type: 'error',
        icon: 'error_outline'
      });
    },


    setItens(event) {
      this.searchFilter = event
      const data = {
        page: this.page,
        maxResults: this.itensPage,
        identification: this.$store.getters.identificationClient,
      }

      switch (event) {
        case filterConst.FILTERDATE:
        case filterConst.FILTERMODEL:
          if (this.model) {
            data.model = this.model
          }
          break;
        case filterConst.FILTERDOCKEY:

          data.docKey = this.chaveAcesso
          break;
        case filterConst.FILTERNUMBER:
          data.number = this.number
          break;
        case filterConst.FILTERCUSTOMERNAME:
          data.customerName = this.customerName
          break;
        case filterConst.FILTERCUSTOMERDENTIFICATION:
          data.customerIdentification = this.removeCharacters(this.customerIdentification)
          break;
        case filterConst.FILTERSTATUS:
          data.status = this.statusDoc
          break;
        default:
          return;
      }

      if (this.dateEmissionTo != null && this.dateEmissionFrom != null) {
        data.fromEmission = moment(this.dateEmissionFrom).format('YYYY-MM-DD')
        data.toEmission = moment(this.dateEmissionTo).format('YYYY-MM-DD')
      }

      if (this.model) {
        data.model = this.model
      }

      this.$store.commit('SET_DOC_FILTRED', data)
      this.$store.dispatch('getDocumentsFilter')
    },

    onChangePage(page) {
      this.page = page;
      if (this.searchFilter) {
        this.$store.commit('SET_PAGE', page)
        this.setItens(this.searchFilter)
        this.selected = []
        return
      }
      this.selected = []
      this.$store.commit('SET_PAGE', page)
      this.$store.dispatch('getDocuments')
    },

    setDefault() {
      this.chaveAcesso = ''
      this.dateEmissionFrom = null
      this.dateEmissionTo = null
      this.model = null
      this.number = null
      this.customerName = null
      this.customerIdentification = null
      this.typeFilter = '1'
      this.searchFilter = 0
      this.$store.commit('SET_PAGE', 1)
      this.$store.commit('SET_MAX_RESULTS', 15)
      this.$store.dispatch('getDocuments')
    },

    setRegisterPerPage() {
      this.selected = []
      this.itensPage = this.registers;

      const data = {
        page: this.page,
        maxResults: this.registers,
        identification: this.$store.getters.identificationClient,
      }

      if (this.dateEmissionTo != null && this.dateEmissionFrom != null) {
        data.fromEmission = moment(this.dateEmissionFrom).format('YYYY-MM-DD')
        data.toEmission = moment(this.dateEmissionTo).format('YYYY-MM-DD')
      }

      this.$store.commit('SET_DOC_FILTRED', data)
      this.$store.dispatch('getDocumentsFilter')
    },

    async downloadXmlSelected(resultIds) {
      await http.post('clipp.download-xml-files', {
        ids: resultIds,
        identification: this.$store.getters.identificationClient,
      })
        .then(response => {
          const link = document.createElement('a')
          link.href = response.data.url
          link.click()
          this.$store.commit('SET_LINK_DOWNLOAD', response.data.url)
          swal.stopLoading()
          swal.close()
        })
        .catch(error => {
          this.$toasted.show(error.response.data.error_message, {
            theme: 'outline',
            position: 'bottom-right',
            duration: 6000,
            type: 'error',
            icon: 'error_outline'
          });
          swal.stopLoading()
          swal.close()
        })
    },

    async downloadXmlFilter(resultIds) {
      for (let i = 0; i < resultIds.length; i++) {
        await http.post('clipp.download-xml-files', {
          ids: resultIds[i],
          identification: this.$store.getters.identificationClient,
        })
          .then(response => {
            this.$store.commit('SET_LOADING_STATUS', false)
            const link = document.createElement('a')
            link.href = response.data.url
            link.click()

            if (i + 1 === resultIds.length) {
              swal.stopLoading()
              swal.close()
            }
          })
          .catch(() => {
            this.$toasted.show('Não foi possível fazer o download.', {
              theme: 'outline',
              position: 'bottom-right',
              duration: 6000,
              type: 'error',
              icon: 'error_outline'
            });
            swal.stopLoading()
            swal.close()
            this.$store.commit('SET_LOADING_STATUS', false)
          })
      }
    },

    formatDate(value) {
      return moment(String(value)).format('DD/MM/YYYY hh:mm:ss')
    },

    cleanIdentification(value) {
      return value.replace(/\^|~|\?|,|\*|\.|-|\/|/g, '');
    },

    backHome() {
      this.$router.push({ path: '/accountant/dashboard' })
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/accountant/documents/Documents.vue